import { WarningOutlined } from "@ant-design/icons";
import { t } from "@lingui/macro";
import React from "react";
import { AppName } from "../../../containers/AppPage/ControlPanel/Apps/enums/AppName";
import { store } from "../../../redux/store";
import { getAuth } from "../helper/utils/getAuth";

/**

 * @param {*} miscellaneousSpecs {
 *  allowedCountryCodes: String[]
 *  settingsRequired: String[]
 *  appsRequired: String[] / Enum[]
 * }
 * @returns {
 *  miscellaneousKey: {
 *    allowed: Boolean,
 *    messageIfBlocked: String,
 *    iconIfBlocked: React.Component
 *  }
 * }
 */
export function checkMiscellaneousFn(miscellaneousSpecs) {
    const {
        allowedCountryCodes,
        settingsRequired,
        appsRequired,
    } = miscellaneousSpecs;

    // check allowedCountryCodes
    const { company, apps } = getAuth();
    const { country_code } = company || {};

    // check settings required
    const { List } = store.getState();
    let settingsAllowed = true,
        settingsMessageIfBlocked, settingsIconIfBlocked,
        appsAllowed = true,
        appsMessageIfBlocked, appsIconIfBlocked;

    settingsRequired.forEach(settingKey => {
        // all settings must be true to pass
        settingsAllowed = settingsAllowed && (List || {}).settings?.[settingKey];
        switch (settingKey) {
            case "is_myinvois_submission_enabled":
                settingsMessageIfBlocked = t`Please turn on MyInvois Submission in company settings to access this module.`;
                settingsIconIfBlocked = <WarningOutlined />;
                break;
            default:
                settingsMessageIfBlocked = t`Please turn on the required settings in company settings to access this module.`;
                settingsIconIfBlocked = <WarningOutlined />;
                break;
        }
    });

    // check apps activation required
    appsRequired.forEach(appName => {
        // all apps must be activated/true to pass
        appsAllowed = appsAllowed && apps.find(app => app.name === appName)?.is_activated;
        switch (appName) {
            case AppName.MINIPOS:
                appsMessageIfBlocked = t`Please activate MiniPOS in Control Panel -> Apps to access this module.`;
                appsIconIfBlocked = <WarningOutlined />;
                break;
            default:
                settingsMessageIfBlocked = t`Please activate the app in Control Panel -> Apps to access this module.`;
                settingsIconIfBlocked = <WarningOutlined />;
                break;
        }
    });

    return {
        allowedCountryCodes: {
            allowed: allowedCountryCodes.length === 0 || allowedCountryCodes.includes(country_code),
            messageIfBlocked: t`This content is not accessible from your country.`,
            iconIfBlocked: <WarningOutlined />,
        },
        settingsRequired: {
            allowed: settingsAllowed,
            messageIfBlocked: settingsMessageIfBlocked,
            iconIfBlocked: settingsIconIfBlocked,
        },
        appsRequired: {
            allowed: appsAllowed,
            messageIfBlocked: appsMessageIfBlocked,
            iconIfBlocked: appsIconIfBlocked,
        },
    };
}
